import React, { useContext, useEffect, useState } from 'react'
import { Alert, Form, Card, Toast, ToastContainer } from 'react-bootstrap';
import { FormErrorContextProvider } from './FormErrorContext';
import _ from 'lodash'
import { MessagesContext } from '../messages/MessagesContext'
import PageContentContainer from './PageContentContainer';

export const FormContainer = (props) => {

    let formErrorMap = props?.errors?.errors;
    const { messages } = useContext(MessagesContext);

    let [show, showToast] = useState(false);
    let [fieldErrors, setFieldErrors] = useState([])
    let [toastStyle, setToastStyle] = useState({});
    let [toastHeading, setToastHeading] = useState("");
    let [toastBody, setToastBody] = useState("");
    let [toastBg, setToastBg] = useState("");
    let [toastAutoHide, setToastAutoHide] = useState(false);

    const toastCloseFunc = props.toastCloseFunc;

    useEffect(() => {
        let formErrMessg = props?.errors?.message;
        let formErrorMessgKey = props?.errors?.messageKey;
        let errorMessage = formErrorMessgKey ? messages[formErrorMessgKey] : "" || formErrMessg;
        let infoMessage = props?.successmessage?.message || props.infoMessage;

        setFieldErrors(props?.errors?.errors);

        if (infoMessage) {
            showToast(true);
            setToastStyle({ backgroundColor: '#5cb85c' });
            setToastHeading("Info")
            setToastBody(infoMessage);
            setToastBg("info");
            setToastAutoHide(true);

        }
        if (errorMessage) {

            showToast(true);
            setToastStyle({ backgroundColor: '#ff0000' });
            setToastHeading("Error")
            setToastBody(errorMessage);
            setToastBg("warning");
            setToastAutoHide(false);
        }

    }, [props]);


    return (
        <PageContentContainer>
            <Card style={{ overflowX: 'auto' }}>
                {props.title &&
                    <Card.Header>
                        <Card.Title>
                            <h6>
                                {props.title}
                                {props.titleComponent ? (<props.titleComponent />) : <></>}
                            </h6>
                        </Card.Title>
                    </Card.Header>}
                <Card.Body>
                    <ToastContainer style={{ zIndex: 99999, position:'fixed',top:'100px', right:'40px'  }} >
                        <Toast style={toastStyle} bg={toastBg} onClose={() => {
                            showToast(false);
                            if (toastCloseFunc) {
                                toastCloseFunc()
                            }
                        }}
                            show={show} delay={2500} autohide={toastAutoHide}>
                            <Toast.Header closeLabel='' closeButton="false">
                                <strong className="me-auto">{toastHeading}</strong>
                            </Toast.Header>
                            <Toast.Body>
                                {toastBody}<br />
                                {fieldErrors && Object.entries(fieldErrors).map(([key, value]) => (
                                    <React.Fragment key={key}>
                                        <strong key={key}>{key}:</strong> {value} <br />
                                    </React.Fragment>
                                ))}
                            </Toast.Body>
                        </Toast>
                    </ToastContainer>


                    <FormErrorContextProvider formErrors={formErrorMap}>
                        <Form onSubmit={props.submitButtonFunction} autoComplete="chrome-off" className={props.className}>
                            {/*errorMessage && <Alert key="danger1" variant="danger">
                                {errorMessage}
                            </Alert>}
                            {infoMessage && <Alert key="info1" variant="info">
                                {infoMessage}
                            </Alert>*/}
                            {props.children}

                        </Form>

                    </FormErrorContextProvider>

                </Card.Body>
            </Card>
        </PageContentContainer>
    )
}